import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const addWarehouseWithUser = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/warehouse/api/v1/brand/' +
      brandId +
      '/ware-house-user',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateWarehouseWithUser = (brandId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/warehouse/api/v1/brand/' +
      brandId +
      '/ware-house-user',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// export const getWarehouseUser = brandId => {
//   return axios({
//     method: 'get',
//     url:
//       STORE_BASE_URL +
//       '/warehouse/api/v1/brand/' +
//       brandId +
//       '/ware-house-user',
//     headers: getHeaders(),
//   });
// };

export const getWarehouseUser = (brandId, warehouseId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/warehouse/api/v1/brand/' +
      brandId +
      '/ware-house/' + warehouseId + '/user',
    headers: getHeaders(),
  });
};
